<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" fullscreen :before-close="closeDialog" width="30%">
      <span>请联系我们:</span>
      <p>企业邮箱：market@hjzddata.com</p>
      <!-- <p>联系电话：0512-83669089</p> -->
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeDialog()">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "AddDialog",
  data() {
    return {
      dialogVisible: true
    };
  },
  methods: {
    closeDialog() {
      this.$emit("update:SHOW", false);
    }
  }
};
</script>
<style lang="scss">
.el-dialog {
  width: 30rem !important;
  height: 300px!important;
  margin-top: 35vh !important;
  .el-dialog__body {
    text-align: center;
    span {
      display: block;
      font-size: 1.2rem;
      color: #5772fe;
    }
    p {
      margin-top: 1rem;
      font-size: 0.9rem;
    }
  }
  .el-button{
    padding:12px 20px!important;
  }
}
</style>